import React from 'react';

interface PaymentStatusModalProps {
    status: 'success' | 'failed' | 'cancel' | 'verifying' | 'pending';
    invoiceId: string | null;
    onClose: () => void;
}

const PaymentStatusModal: React.FC<PaymentStatusModalProps> = ({ status, invoiceId, onClose }) => {
    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/80 backdrop-blur-sm animate-fadeIn p-4">
            <div className="bg-slate-900 border border-white/10 rounded-3xl p-8 max-w-md w-full shadow-2xl relative overflow-hidden">

                {/* Background Glow */}
                <div className={`absolute top-0 left-0 w-full h-2 bg-gradient-to-r ${status === 'success' ? 'from-emerald-500 to-green-400' :
                        status === 'failed' ? 'from-red-500 to-orange-500' :
                            status === 'verifying' ? 'from-sky-500 to-blue-500 animate-pulse' :
                                'from-slate-500 to-gray-400'
                    }`} />

                <div className="text-center space-y-6">
                    <div className={`w-24 h-24 rounded-full mx-auto flex items-center justify-center text-5xl mb-4 ${status === 'success' ? 'bg-emerald-500/10 text-emerald-500' :
                            status === 'failed' ? 'bg-red-500/10 text-red-500' :
                                status === 'verifying' ? 'bg-sky-500/10 text-sky-500 animate-pulse' :
                                    'bg-slate-700/30 text-slate-400'
                        }`}>
                        {status === 'success' ? '✅' : status === 'failed' ? '❌' : status === 'verifying' ? '⏳' : '🔙'}
                    </div>

                    <div>
                        <h2 className="text-2xl font-black text-white mb-2">
                            {status === 'success' ? 'Zahlung erfolgreich!' :
                                status === 'failed' ? 'Zahlung fehlgeschlagen' :
                                    status === 'verifying' ? 'Wird geprüft...' :
                                        status === 'pending' ? 'Verarbeitung läuft...' :
                                            'Abgebrochen'}
                        </h2>
                        <p className="text-slate-400">
                            {status === 'success' ? 'Vielen Dank! Dein Abo oder deine Tokens wurden gutgeschrieben.' :
                                status === 'failed' ? 'Leider konnte die Zahlung nicht abgeschlossen werden.' :
                                    status === 'verifying' ? 'Wir warten auf die Bestätigung von Payrexx.' :
                                        status === 'pending' ? 'Deine Zahlung ist eingegangen, aber noch nicht final bestätigt.' :
                                            'Der Zahlungsvorgang wurde abgebrochen.'}
                        </p>
                    </div>

                    {status === 'success' && invoiceId && (
                        <div className="bg-slate-800/50 rounded-lg p-3 text-sm text-slate-500 font-mono">
                            Ref: {invoiceId.split('-')[0]}...
                        </div>
                    )}

                    {status !== 'verifying' && (
                        <button
                            onClick={onClose}
                            className={`w-full py-4 rounded-xl font-bold uppercase tracking-widest transition-all ${status === 'success' ? 'bg-emerald-600 hover:bg-emerald-500 text-white shadow-lg shadow-emerald-900/20' :
                                    'bg-slate-700 hover:bg-slate-600 text-white'
                                }`}
                        >
                            {status === 'success' ? 'Weiter zur App' : 'Schließen'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentStatusModal;
